import { TextField } from "@mui/material";
import { useController } from "react-hook-form";

const CustomTextField = ({ field, control }) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });

  return (
    <TextField
      name={field.name}
      label={field.label}
      variant="outlined"
      fullWidth
      type={"text"}
      helperText={fieldState.error?.message || field.help_text || ""}
      disabled={field.disabled}
      sx={{ display: field.hidden ? "none" : "block" }}
      error={!!fieldState.error}
      {...fieldProps}
    />
  );
};

export default CustomTextField;
